import { render } from "./GeneralContent.vue?vue&type=template&id=66354a08"
import script from "./GeneralContent.vue?vue&type=script&lang=js"
export * from "./GeneralContent.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__